import { WeaTools } from "ecCom";

/**
 * 工作流-签章初始化信息
 * @param params
 * @returns {*}
 */
export const getAutographInfo = params => {
  //TODO
  return WeaTools.callApi(
    "/api/workflow/nodeSet/getNodeSignatureForEdit",
    "POST",
    params
  );
};



// WEBPACK FOOTER //
// ./comMobx/wea-autograph/apis/autographApi.js